import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MockShell } from './MockShell.js';
import { TesterApp } from './TesterApp.js';
import './styles.css';

const root = document.querySelector<HTMLElement>('#root');

if (!root) {
  throw new Error('Missing #root element.');
}

const content =
  window.location.pathname === '/app' ? <TesterApp /> : <MockShell />;

createRoot(root).render(<StrictMode>{content}</StrictMode>);
